module.exports = __webpack_public_path__ + "static/media/21ECLAC21.350d0106.jpg";